export const zoneColors = ["#A90120", "#EF7F31", "#F8DF59"];

export const propertyInZoneCardBorderColor = ["#D10027", "#E96000", "#E0BD00"];

export const propertyInZoneCardColor = ["#FAE6E9", "#FDEFE6", "#FCF8E6"];
